import * as React from 'react';

function Copyright() {
  // Get the current year dynamically
  const currentYear = new Date().getFullYear();

  return React.createElement(
    'div', // Ensure the parent element is valid (e.g., 'div' instead of 'copyright', which is not standard)
    { className: 'copyright-container' },
    React.createElement(
      'p',
      { className: '', style: { textAlign: 'center' } },
      `Copyright © ${currentYear} `,
      React.createElement(
        'a',
        {
          href: 'https://menulynx.com',
          target: '_blank',
          rel: 'noopener noreferrer',
          className: 'menulynx-link',
        },
        'Menulynx.com'
      ),
      '. All rights reserved.'
    )
  );
}

export default Copyright;
